const checkRequired = (value) => (value ? false : 'required');
const checkRequiredAllowZero = (value) => (value === 0 || value ? false : 'required');
const checkPositiveNumber = (value) => (value > 0 ? false : 'incorrect');
const checkPositiveOrZeroNumber = (value) => (value >= 0 ? false : 'incorrect');
const checkEmail = (value) => (!value || /^[^@]+@[^.]+\..+$/.test(value) ? false : 'incorrect');
const checkPhone = (value) => (!value || /^\+(?!0)[0-9](?: ?[0-9]){5,13}$/.test(value) ? false : 'incorrect');

export { checkRequired, checkRequiredAllowZero, checkPositiveNumber, checkEmail, checkPhone, checkPositiveOrZeroNumber };
